import React from "react"
import PropTypes from "prop-types"
import { Link } from "react-router-dom"
import { Row, Col, BreadcrumbItem } from "reactstrap"

const Breadcrumb = props => {
  return (
    <Row>
      <Col className="col-12">
        <div className="page-title-box d-sm-flex align-items-center justify-content-between">
          <h4 className="mb-sm-0 font-size-18">{props.breadcrumbItem}</h4>
          <div className="page-title-right d-sm-flex align-items-center gap-4">
            <div className="d-flex align-items-center justify-content-center gap-2">
              {props.isCityFilter && (
                <Col
                  className="d-flex align-items-center justify-content-center gap-2"
                >
                  <label htmlFor="city" className="form-label">
                    {" "}
                    City:{" "}
                  </label>
                  <select
                    id="city"
                    className="form-select"
                    value={props?.city}
                    onChange={event => props.setCity(event.target.value)}
                  >
                    {props?.cities?.length > 0 ? (
                      <>
                        <option value="All">All</option>
                        {props?.cities?.map((city, i) => (
                          <option key={i} value={city?._id}>
                            {city?.name}
                          </option>
                        ))}
                      </>
                    ) : (
                      <option value="All">No Cities Available</option>
                    )}
                  </select>
                </Col>
              )}
            </div>
            <ol className="breadcrumb m-0">
              <BreadcrumbItem>
                <Link to="#">{props.title}</Link>
              </BreadcrumbItem>
              <BreadcrumbItem active>
                <Link to="#">{props.breadcrumbItem}</Link>
              </BreadcrumbItem>
            </ol>
          </div>
        </div>
      </Col>
    </Row>
  )
}

Breadcrumb.propTypes = {
  breadcrumbItem: PropTypes.string,
  title: PropTypes.string,
}

export default Breadcrumb
